var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bracket-header-round"},[_vm._v("Этап "+_vm._s(_vm.roundDescription))])}
var staticRenderFns = []

export { render, staticRenderFns }